// extracted by mini-css-extract-plugin
export default {"wrap":"BackendSearchSelect_wrap__N+Wr1"};